import { Box } from '@mui/material';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { getUserIsAuthed } from 'entities/User';
import { USER_ACCESS_TOKEN } from 'shared/const/localstorage';
import { getUrlMobileApp } from 'shared/const/mobileRoutes';
import { isMobile } from 'shared/const/platforms';
import { getRouteMain } from 'shared/const/router';

export const OnboardMobileUserPage = memo(() => {
    const auth = useSelector(getUserIsAuthed);

    if (!isMobile() || !auth) {
        return <Navigate to={getRouteMain()} replace />;
    } else {
        window.location.replace(
            getUrlMobileApp(localStorage.getItem(USER_ACCESS_TOKEN)),
        );
    }

    return (
        <Box display="flex" alignItems="center" justifyContent="center"></Box>
    );
});
